import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { ajaxPost } from '../../ajax'
import Form from '../stripe-payment-form/form'
import { caclulateFee } from '../../shop/common'

function StripePluginModal({currency, amount, reservation, token, location, playerId, stripe, fees, store}) {
  const stripePromise = loadStripe(stripe.publishable_key, {stripeAccount: stripe.account})
  const {fee, feeInPrice} = caclulateFee(fees, amount)
  const [error, setError] = useState(null)

  const updateSlots = reservationInfo => {
    [...Array(reservationInfo.duration / 0.5)].map((_, i) => {
      const timestamp = reservationInfo.timestamp + (i * 1800)
      const search_str = `[data-location='${reservationInfo.location_id}'][data-field='${reservationInfo.field_id}'][data-timestamp='${timestamp}']`
      const slot = document.querySelectorAll(search_str)[0]
      slot.classList.remove('btn-success')
      slot.classList.add('btn-danger')
      slot.innerHTML = 'Booked'
      slot.setAttribute('disabled', true)
    })
  }

  const onPayment = (result) => {
    const params = {
      reservation: { ...reservation },
      player_id: playerId,
      payment: { type: result.type, token: result.token },
      token: token
    }

    ajaxPost('/components/payment', params)
    .then(response => response.json())
    .then(json => {
      json.error ? onPaymentFailure(json.error) : onPaymentSuccess(json.reservation_info)
    })
  }

  const onPaymentSuccess = (info) => {
    const modal = document.getElementById('plugin-reservation')
    const header = modal.getElementsByTagName('h4')[0]
    const body = modal.getElementsByClassName('modal-body')[0]
    header.getElementsByClassName('title')[0].textContent = ('Reservation Successful!')
    body.innerHTML = `
      <div class="row">
        <div class="col-xs-12">
          <p>
           You’ve reserved ${info.field_name} at ${info.location_name} at ${info.date_with_time.trim()}
          </p>
        </div>
      </div>
    `
    updateSlots(info)
  }

  const onPaymentFailure = (error) => {
    setError(error)
  }

  const onClose = () => {
    const modal = document.getElementById('plugin-reservation')
    modal.getElementsByClassName('close')[0].click()
  }

  return (
    <div className='stripe-panel'>
      <Elements stripe={stripePromise}>
        <Form
          currency={currency}
          amount={amount + fee}
          appFee={fee + feeInPrice}
          token={token}
          location={location}
          onClose={onClose}
          onPayment={onPayment}
          storeOnly={store}
          serverError={error}
        />
      </Elements>
    </div>
  )
}

StripePluginModal.propTypes = {
  amount: PropTypes.number.isRequired,
  reservation: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  location: PropTypes.number.isRequired,
  stripe: PropTypes.object.isRequired,
  playerId: PropTypes.string.isRequired,
  fees: PropTypes.object.isRequired,
}

export default StripePluginModal
